import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router, Routes} from '@angular/router';
import {TableHeaderService} from '../../../../resources/services/table-header.service';
import {UserService} from '../../../../resources/services/user.service';
import {ModalBonusComponent} from '../../../../resources/components/modals/modal-bonus/modal-bonus.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {StoreVersionService} from '../../../../resources/services/store-version.service';
import {DeleteService} from '../../../../resources/services/delete.service';

@Component({
  selector: 'user-view-info',
  templateUrl: './user-view-info.component.html'
})
export class UserViewInfoComponent implements OnInit {

  id: any = this._route.parent.snapshot.params.id;
  item: any;

  constructor(private tableHeaderService: TableHeaderService,
              private _route: ActivatedRoute,
              private _router: Router,
              private _modelService: UserService,
              private modalService: BsModalService,
              private deleteService: DeleteService) {
  }

  ngOnInit(): void {
    this.get();
  }

  get(): void {
    this._modelService.get({
      id: this.id,
      relations: ['account', 'devices', 'store']
    }).subscribe((res: any) => {
          this.item = res;
        },
        err => {
        }
      );
  }

  addPurchase() {
    this.modalService.show(ModalBonusComponent, {
      initialState: {
        user: this.id,
        // store: this.item?.store?.id
      },
      backdrop: 'static'
    })
  }

  // delete() {
  //   this._modelService.delete(this.id)
  //     .subscribe(() => {
  //         this._router.navigate(['../../../'], { relativeTo: this._route })
  //       }, err => {
  //         console.log(err);
  //       }
  //     );
  // }
  delete(item) {
    this._router.navigate(['../../../'], {relativeTo: this._route});

    this.deleteService.process(item.type, item.version).then(() => {
      this._modelService.delete(this.id).subscribe();
    });
  }
}
